/* BRS product options: required-field and file checks, plus conditional fields (data-show-when="Field||Value").
   Inputs attach to the product form via the form attribute, so the theme's own add-to-cart submits them,
   file uploads included. This element only steps in to block an invalid submit. */
if (!customElements.get('brs-options')) {
  customElements.define('brs-options', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.error = this.querySelector('.brs-engraving__error');
      this.addEventListener('input', () => this.hideError());
      this.addEventListener('change', (e) => { this.hideError(); if (e.target.type === 'file') this.checkFile(e.target); this.applyConditions(); });
      this.submitHandler = (e) => { if (e.target === this.form && !this.validate()) { e.preventDefault(); e.stopImmediatePropagation(); } };
      document.addEventListener('submit', this.submitHandler, true);
      this.applyConditions();
    }

    disconnectedCallback() { document.removeEventListener('submit', this.submitHandler, true); }

    valueOf(fieldLabel) {
      const wrap = this.querySelector(`[data-field="${CSS.escape(fieldLabel)}"]`);
      if (!wrap) return '';
      const r = wrap.querySelector('input[type=radio]:checked');
      if (r) return r.value;
      const s = wrap.querySelector('select, input[type=text]');
      return s ? s.value : '';
    }

    applyConditions() {
      this.querySelectorAll('[data-show-when]').forEach((wrap) => {
        const [field, value] = wrap.dataset.showWhen.split('||');
        const show = this.valueOf(field) === value;
        wrap.hidden = !show;
        wrap.querySelectorAll('input, select').forEach((el) => { el.disabled = !show; });
      });
    }

    showError(msg, focusEl) {
      this.error.textContent = msg;
      this.error.hidden = false;
      if (focusEl && focusEl.focus) focusEl.focus();
      this.error.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    hideError() { if (this.error) this.error.hidden = true; }

    checkFile(input) {
      const f = input.files && input.files[0];
      if (!f) return true;
      const maxMb = parseFloat(input.dataset.maxMb || '20');
      if (!/\.(jpe?g|png|heic|svg|pdf)$/i.test(f.name)) { input.value = ''; this.showError('That file type will not work. Use JPG, PNG, HEIC, SVG or PDF.', input); return false; }
      if (f.size > maxMb * 1024 * 1024) { input.value = ''; this.showError(`That file is over ${maxMb} MB. Please send a smaller one.`, input); return false; }
      return true;
    }

    validate() {
      const groups = {};
      for (const el of this.querySelectorAll('input, select')) {
        if (el.disabled) continue;
        if (el.type === 'file') { if (!this.checkFile(el)) return false; if (el.required && !(el.files && el.files.length)) return this.showError(`Please upload ${this.labelFor(el)}.`, el), false; continue; }
        if (el.type === 'radio') { if (el.required) (groups[el.name] = groups[el.name] || []).push(el); continue; }
        if (el.required && !el.value.trim()) return this.showError(`Please choose ${this.labelFor(el)}.`, el), false;
      }
      for (const name in groups) {
        if (!groups[name].some((r) => r.checked)) {
          const legend = groups[name][0].closest('fieldset').querySelector('legend');
          return this.showError(`Please choose ${legend ? legend.childNodes[0].textContent.trim().toLowerCase() : 'an option'}.`, groups[name][0]), false;
        }
      }
      return true;
    }

    labelFor(el) {
      const label = el.id && this.querySelector(`label[for="${el.id}"]`);
      return label ? label.childNodes[0].textContent.trim().toLowerCase() : 'this field';
    }
  });
}
